import { XMarkIcon } from "@heroicons/react/24/outline";
import * as Dialog from "@radix-ui/react-dialog";
import clsx from "clsx";
import Image from "next/legacy/image";
import { useState } from "react";

const NoteImages = ({ imageUrls }: { imageUrls: string[] }) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  return (
    <div>
      {imageUrls && imageUrls.length > 0 && (
        <div className={clsx("flex flex-wrap gap-2 py-4")}>
          {imageUrls.map((url, index) => (
            <Dialog.Root
              key={url}
              open={selectedImage === url}
              onOpenChange={(open) => setSelectedImage(open ? url : null)}
              modal
            >
              <Dialog.Trigger asChild>
                <div
                  className={clsx(
                    "relative h-24 w-24 cursor-pointer overflow-hidden rounded-lg bg-zinc-100"
                  )}
                >
                  <Image
                    src={url}
                    alt={`Note image ${index + 1}`}
                    className={clsx("object-cover")}
                    layout="fill"
                    sizes="96px"
                  />
                </div>
              </Dialog.Trigger>
              <Dialog.Portal>
                <Dialog.Overlay
                  className={clsx(
                    "fixed inset-0 z-[51] bg-zinc-800 bg-opacity-50 backdrop-blur-sm"
                  )}
                />
                <Dialog.Content
                  className={clsx(
                    "fixed inset-0 z-[52] flex items-center justify-center focus:outline-none"
                  )}
                >
                  <div
                    className={clsx(
                      "relative h-full max-h-[90vh] w-full max-w-[90vw]"
                    )}
                    onClick={() => setSelectedImage(null)}
                  >
                    <Image
                      src={url}
                      alt={`Note image ${index + 1}`}
                      className={clsx("object-contain")}
                      layout="fill"
                      sizes="90vw"
                    />
                  </div>
                  <Dialog.Close
                    className={clsx(
                      "absolute right-6 top-6 text-white hover:text-gray-300 focus:outline-none"
                    )}
                  >
                    <XMarkIcon
                      className={clsx(
                        "h-6 w-6 stroke-[1.5] lg:h-8 lg:w-8 lg:stroke-[1]"
                      )}
                    />
                  </Dialog.Close>
                </Dialog.Content>
              </Dialog.Portal>
            </Dialog.Root>
          ))}
        </div>
      )}
    </div>
  );
};

export default NoteImages;
